import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export interface IBaseAPIResponse {
  status: boolean;
}

export interface IDecodedVin {
  make: string;
  body_type: string;
  vehicle_type: string;
  model_year: string;
  model: string;
  transmission: string;
  seats: string;
  drive: string;
  cyllinder: string;
  door: string;
  hp: string;
  cc: string;
  trim: string;
  engine_type: string;
  fuel_type: string;
  gear: string;
}

export interface IDecodedVinResponse extends IBaseAPIResponse {
  data: IDecodedVin;
}

@Injectable({
  providedIn: 'root'
})
export class AutoDataService {
  constructor(public http: HttpClient) {}

  decodeVin(vin: string) {
    return this.http.post<IDecodedVinResponse>(`${environment.api}/decode-vin`, {
      vin
    });
  }
}
